import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Prescription } from '@lib/prescriptions/data-access';
import { TranslatePipe } from '@ngx-translate/core';

import { ObjectChange } from '@lib/shared-ui/core/utils/generate-object-changes.function';

import { PrescriptionChangesListItemComponent } from './prescription-changes-list-item/prescription-changes-list-item.component';

@Component({
  selector: 'prescriptions-changes-list',
  standalone: true,
  imports: [TranslatePipe, PrescriptionChangesListItemComponent],
  templateUrl: './prescription-changes-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionChangesListComponent {
  prescriptionChanges = input.required<ObjectChange<Prescription>[]>();
}
